import loadBasketModule from './modules/Basket.module';
const loadProductInspirationModule = () => ({
    hasRouter: false,
    modules: [loadBasketModule()],
});
export default loadProductInspirationModule;
